import { USER_LIMIT_COUNT } from 'app/developer-v3/constants';

/**
 * We render different reasons for a non editable integration.
 * If the app is public and the user limit count is bigger than
 * the established, we render the number of users
 *
 * If the user count is lesser than the limit, we render a
 * message explaining the integration is public
 *
 * @param userCount
 */
export const getNonEditableUiReason = (userCount: number) =>
  userCount >= USER_LIMIT_COUNT
    ? `has more than ${USER_LIMIT_COUNT} active users`
    : 'is already public';

export const disableFields = (fields = [], isDisabled) =>
  fields.map(f => {
    return { ...f, readOnly: isDisabled };
  });
